import React from "react";
import NotFoundSVG from './../../assets/images/404.svg';
import {Link} from 'react-router-dom';
const NotFound = () => {
    return(
        <>
            <div className="not-found-holder">
                <img src={NotFoundSVG} alt="" width={600}/>
                <div className="text-13">صفحه مورد نظر یافت نشد!</div>
                <Link to="/" className="btn btn-small btn-warning text-13">بازگشت به پنل</Link>
            </div>
        </>
    )
}

export default NotFound;